import { InjectionToken } from '@angular/core';

export type TranslateFn = (
  key: string,
  optionsOrDefault?: Record<string, any>,
  options?: Record<string, any>
) => string;

export const TRANSLATE_FN = new InjectionToken<TranslateFn>('core-util.translateFn');

export const I18N_NAMESPACE = new InjectionToken<string | string[]>('core-util.translationI18nNamespace', {
  factory: () => 'website'
});
